import { styled } from 'next-yak';

// *** Components ***

export const XingLogo = styled.div``;
